export interface UploadOptions {
  fileNo: string
  file: File
  documentId: string
  documentName?: string
  docFieldName?: string
}
